import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { GlobalFunctionsService } from '@_services/global-functions.service';
import { Subject, takeUntil } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { SortingBehaviourService } from '@_services/sorting-behaviour.service';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-partner-distribution',
  templateUrl: './partner-distribution.component.html',
  styleUrls: ['./partner-distribution.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PartnerDistributionComponent implements OnInit, OnDestroy {
  SettingForm: FormGroup;
  @Input() errorWarningData: any;
  isspiner: boolean = false;
  confirmDialogRef: any;
  secondData: boolean = true;
  firstData: boolean = false;
  getDataForTable: any = [];
  highlightedRows: any;
  theme_type = localStorage.getItem('theme_type');
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;
  isExpandedRow = (_index: number, row: any): boolean => !!row?.expanded;
  selectedColore: string = 'var(--highlighted-bg-row)';
  showDate: any;
  sendDate: any;
  whichType: any;
  FormAction: any;
  CurrentRowselcted: any = {};
  sendInterstGUID: any;
  @Output() callLoading = new EventEmitter<string>();
  displayedColumns: string[] = ['Action', 'EFFECTIVEFROMAMOUNT', 'DISTRIBUTIONPERCENT'];
  maintainFlag: boolean = false;
  class: boolean;
  ShowDuplicateBotton: boolean;
  private _unsubscribeAll$: Subject<void> = new Subject();
  isLoadingResults: boolean;
  sortingDefaultState: any = {};
  sortactive: any;
  sortDirection: any;
  user_partner_distribution_rate = [];
  @ViewChild('effFromRef') effFromRef!: ElementRef<HTMLInputElement>;
  @ViewChild('effFromEditRef') effFromEditRef!: ElementRef<HTMLInputElement>;
  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    private behaviorService: BehaviorService,
    public _matDialog: MatDialog,
    private SortingbehaviorService: SortingBehaviourService,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    private globalFunService: GlobalFunctionsService,
    private formbuilder: FormBuilder,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingInterstRatesComponent');
    this.behaviorService.APIretryCall$.pipe(takeUntil(this._unsubscribeAll$)).subscribe(
      (result) => {
        if (
          localStorage.getItem('istrackid') == 'SystemSettingInterstRatesComponent' &&
          result['click'] &&
          result['data']['user-partner-distribution-rate']
        ) {
          this.finalSave('save');
        }
      },
    );

    this.SortingbehaviorService.accountSystemSortingPartner$.subscribe((result) => {
      if (result) {
        this.sortingDefaultState = result;
        localStorage.setItem('account_system_screen_sorting_Partner', JSON.stringify(result));
      } else {
        this.sortingDefaultState = JSON.parse(
          localStorage.getItem('account_system_screen_sorting_Partner'),
        );
      }
    });
    this.SettingForm = this.formbuilder.group({
      EFFECTIVEFROMAMOUNT: [0],
      DISTRIBUTIONPERCENT: [0],
    });
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.behaviorService.permissionCheckforHeight$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((data) => {
        this.class = data;
      });
    // this.SettingForm.
    // this.SettingForm.controls['EFFECTIVEFROMAMOUNT'].setValue(0);
    // this.SettingForm.controls['DISTRIBUTIONPERCENT'].setValue(0);

    if (this.sortingDefaultState) {
      this.sortactive = this.sortingDefaultState.active;
      this.sortDirection = this.sortingDefaultState.direction;
    } else {
      this.sortactive = '';
      this.sortDirection = '';
    }
    this.loadData();
  }

  formatInputs() {
    if (this.effFromRef?.nativeElement) {
      let value = this.effFromRef.nativeElement.value.replace(/,/g, '');
      if (!value || isNaN(parseFloat(value))) value = '0';
      const floatVal = parseFloat(value);
      this.effFromRef.nativeElement.value = floatVal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    if (this.effFromEditRef?.nativeElement) {
      let value = this.effFromEditRef.nativeElement.value.replace(/,/g, '');
      if (!value || isNaN(parseFloat(value))) value = '0';
      const floatVal = parseFloat(value);
      this.effFromEditRef.nativeElement.value = floatVal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * This funtion is used to load the data value
   */
  loadData() {
    this.isLoadingResults = true;
    const User = JSON.parse(localStorage.getItem('current_user_Data'));
    let Payload = {
      // "ACTION": "default",
      // "DATA": {},
      Action: 'GetData',
      Filters: {
        USERGUID: User?.USERGUID,
      },
    };
    this._mainAPiServiceService
      .getSetData(Payload, 'user-partner-distribution-rate')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe(
        (response) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            // this.getDataForTable = response.DATA.INTERESTRATES;

            if (response.DATA.RECORDS.length > 0) {
              this.user_partner_distribution_rate = response.DATA.RECORDS;
              response.DATA.RECORDS.forEach((element) => {
                element['expanded'] = false;
              });
              this.getDataForTable = new MatTableDataSource<any>(response.DATA.RECORDS);
              this.maintainFlag = false;
              this.highlightedRows = this.getDataForTable.data[0].USERPARTNERDISTRIBUTIONRATEGUID;
              this.CurrentRowselcted = this.getDataForTable.data[0];
              // this.itemChange('edit');
              this.behaviorService.loadingSystemSetting('interst-rates');
              this.sortData();
            } else {
              this.user_partner_distribution_rate = [];
            }
            //  setTimeout(() => {
            //     this.formatInputs();
            //  });
            this.isLoadingResults = false;
          }
        },
        (error) => {
          this.toastr.error(error);
          this.isLoadingResults = false;
        },
      );
  }
  get f() {
    return this.SettingForm.controls;
  }

  /**
   * This function is used to click on the row
   */
  rowclick(val) {
    this.CurrentRowselcted = val;
    this.highlightedRows = val.USERPARTNERDISTRIBUTIONRATEGUID;
    // await this.itemChange('edit');
  }
  CurrencyClassChange(val) {}

  /**
   * This function is used to change the item data value
   */
  itemChange(val) {
    this.whichType = val;
    if (val == 'add') {
      this.secondData = false;
      this.SettingForm.get('EFFECTIVEFROMAMOUNT').enable();
      this.SettingForm.get('DISTRIBUTIONPERCENT').enable();
      this.SettingForm.controls['EFFECTIVEFROMAMOUNT'].setValue(0);
      this.SettingForm.controls['DISTRIBUTIONPERCENT'].setValue('');
      this.firstData = true;
      this.loadDataDefault();
    } else if (val == 'edit') {
      this.SettingForm.get('EFFECTIVEFROMAMOUNT').enable();
      this.SettingForm.get('DISTRIBUTIONPERCENT').enable();
      // if(!isNaN(this.CurrentRowselcted.EFFECTIVEFROMAMOUNT)){
      // this.SettingForm.get('EFFECTIVEFROMAMOUNT').enable();
      // this.SettingForm.get('DISTRIBUTIONPERCENT').enable();
      // }
      this.SettingForm.controls['DISTRIBUTIONPERCENT'].setValue(
        this.CurrentRowselcted.DISTRIBUTIONPERCENT,
      );
      this.secondData = false;
      this.firstData = true;
      // const rawVal = parseFloat(this.CurrentRowselcted.EFFECTIVEFROMAMOUNT);
      const rawVal = Number(this.CurrentRowselcted.EFFECTIVEFROMAMOUNT);
      const formatted = rawVal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      this.SettingForm.controls['EFFECTIVEFROMAMOUNT'].setValue(formatted, {
        emitEvent: true,
      });
    } else if (val == 'DUPLICATE') {
      this.finalSave(val);
    }
  }

  loadDataDefault() {
    this.isLoadingResults = true;
    this._mainAPiServiceService
      .getSetData({ Action: 'Default', Data: {} }, 'user-partner-distribution-rate')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe(
        (response) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isLoadingResults = false;
            // this.SettingForm.patchValue(response.DATA.DEFAULTVALUES);
            // this.SettingForm.controls['EFFECTIVEFROMAMOUNT'].setValue(parseFloat(response.DATA.DEFAULTVALUES.EFFECTIVEFROMAMOUNT).toFixed(2));
            const rawVal = Number(response.DATA?.DEFAULTVALUES?.EFFECTIVEFROMAMOUNT);
            const formatted = rawVal.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            this.SettingForm.controls['EFFECTIVEFROMAMOUNT'].setValue(formatted, {
              emitEvent: true,
            });
            this.SettingForm.controls['DISTRIBUTIONPERCENT'].setValue(
              response.DATA?.DEFAULTVALUES?.DISTRIBUTIONPERCENT,
            );
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.toastr.warning(response.MESSAGE);
            this.isLoadingResults = false;
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.isLoadingResults = false;

            this.toastr.error(response.MESSAGE);
          } else if (response.MESSAGE == 'Not logged in') {
            this.isLoadingResults = false;
          }
        },
        (error) => {
          this.toastr.error(error);
        },
      );
  }

  /**
   * This function is used to exchange the Date
   */
  exchangeDate1(val1, val2) {}

  /**
   * This function is used to exchange the Date
   */
  exchangeDate(type: string, event: MatDatepickerInputEvent<Date>) {
    const formattedDate = this.datepipe.transform(event.value, 'dd/MM/yyyy');
  }

  /**
   * This function is used to dont save
   */
  dontsave() {
    this.firstData = false;
    this.secondData = true;
  }
  finalSave(val) {
    this.isLoadingResults = true;
    this.firstData = false;
    this.secondData = true;
    if (this.whichType == 'add') {
      this.FormAction = 'insert';
      this.sendInterstGUID = '';
    } else if (this.whichType == 'edit') {
      this.FormAction = 'update';
      this.sendInterstGUID = this.CurrentRowselcted.USERPARTNERDISTRIBUTIONRATEGUID;
    } else if (this.whichType == 'delete') {
      this.FormAction = 'delete';
      this.sendInterstGUID = this.CurrentRowselcted.USERPARTNERDISTRIBUTIONRATEGUID;
    } else if (this.whichType == 'DUPLICATE') {
      this.FormAction = 'insert';
    }
    const User = JSON.parse(localStorage.getItem('current_user_Data'));
    const fomrVal = this.SettingForm.controls['EFFECTIVEFROMAMOUNT'].value;
    const finalVal = parseFloat(fomrVal?.toString().replace(/,/g, '')).toFixed(2);
    let sendData = {
      USERPARTNERDISTRIBUTIONRATEGUID: this.sendInterstGUID,
      DISTRIBUTIONPERCENT: this.f.DISTRIBUTIONPERCENT.value,
      EFFECTIVEFROMAMOUNT: finalVal,
      USERGUID: User?.USERGUID,
    };
    if (this.whichType == 'add') {
      delete sendData.USERPARTNERDISTRIBUTIONRATEGUID;
    }
    let details = {
      Action: this.FormAction,
      VALIDATEONLY: true,
      Data: sendData,
    };
    this._mainAPiServiceService
      .getSetData(details, 'user-partner-distribution-rate')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe(
        (response) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isLoadingResults = false;
            this.checkValidation(response.DATA.VALIDATIONS, details);
            this.maintainFlag = false;
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.isLoadingResults = false;
            this.checkValidation(response.DATA.VALIDATIONS, details);
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.isLoadingResults = false;
            this.checkValidation(response.DATA.VALIDATIONS, details);
          } else if (response.MESSAGE == 'Not logged in') {
            this.isLoadingResults = false;
            // this.dialogRef.close(false);
          }
        },
        (error) => {
          this.isspiner = false;
          this.toastr.error(error);
        },
      );
  }
  // checkValidation(bodyData: any, details: any) {
  //   let errorData: any = [];
  //   let warningData: any = [];
  //   let tempError: any = [];
  //   let tempWarning: any = [];
  //   bodyData.forEach(function (value) {
  //     if (value.VALUEVALID == 'No') {
  //       errorData.push(value.ERRORDESCRIPTION);
  //       tempError[value.FIELDNAME] = value;
  //     }
  //     else if (value.VALUEVALID == 'Warning') {
  //       tempWarning[value.FIELDNAME] = value;
  //       warningData.push(value.ERRORDESCRIPTION);
  //     }
  //   });
  //   this.errorWarningData = { "Error": tempError, 'Warning': tempWarning };
  //   if (Object.keys(errorData).length != 0) {
  //     this.toastr.error(errorData);
  //     this.isspiner = false;
  //   } else if (Object.keys(warningData).length != 0) {
  //     this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
  //       disableClose: true,
  //       width: DIALOG_WIDTH.FULL,
  //       data: warningData
  //     });
  //     this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to Save?';
  //     this.confirmDialogRef.afterClosed().subscribe(result => {
  //       if (result) {
  //         this.isspiner = true;
  //         this.saveSpendMoneyData(details);
  //       }
  //       this.confirmDialogRef = null;
  //     });
  //   } else if (Object.keys(warningData).length == 0 && Object.keys(errorData).length == 0) {
  //     this.saveSpendMoneyData(details);

  //   }
  // }
  async checkValidation(bodyData: any, PostActivityData: any, ApiName?: any) {
    this.isspiner = false;
    await this.globalFunService
      .checkValidation(bodyData, PostActivityData)
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((data) => {
        if (data) {
          this.errorWarningData = data.errorWarningData;
          //this.errorWarningDataArray = data.errorWarningData;
          if (data.callback) {
            this.saveSpendMoneyData(PostActivityData);
          }
        }
      });
  }
  saveSpendMoneyData(data: any) {
    this.isLoadingResults = true;
    data.VALIDATEONLY = false;
    this._mainAPiServiceService
      .getSetData(data, 'user-partner-distribution-rate')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe(
        (response) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            if (this.whichType !== 'edit') {
              this.callLoading.next(null);
              this.loadData();
              this.toastr.success('Saved successfully');
            } else {
              this.callLoading.next(null);
              this.loadData();
              this.toastr.success('Updated successfully');
            }
            this.isLoadingResults = false;
            // this.dialogRef.close(true);
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.toastr.warning(response.MESSAGE);
            this.isspiner = false;
            this.isLoadingResults = false;
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.toastr.error(response.MESSAGE);
            this.isspiner = false;
            this.isLoadingResults = false;
          } else if (response.MESSAGE == 'Not logged in') {
            // this.dialogRef.close(false);
            this.isLoadingResults = false;
          }
        },
        (error) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.isLoadingResults = false;
        },
      );
  }
  deleteItem() {
    this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
    });
    this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete?';
    this.confirmDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let postData = {
          Action: 'delete',
          DATA: {
            USERPARTNERDISTRIBUTIONRATEGUID: this.CurrentRowselcted.USERPARTNERDISTRIBUTIONRATEGUID,
          },
        };
        this._mainAPiServiceService
          .getSetData(postData, 'user-partner-distribution-rate')
          .subscribe((res) => {
            if (res.STATUS == 'success' && res.CODE == 200) {
              this.callLoading.next(null);
              this.loadData();
              this.toastr.success('Deleted successfully');
              this.maintainFlag = false;
            }
          });
      }
      this.confirmDialogRef = null;
    });
  }

  toggleRow(element) {
    this.ShowDuplicateBotton = false;
    this.maintainFlag = false;
    this.CurrentRowselcted = element;
    this.itemChange('edit');
    if (element.expanded == true) {
      element.expanded = !element.expanded;
    } else {
      this.getDataForTable.data.forEach((row) => {
        row.expanded = false;
      });
      element.expanded = !element.expanded;
    }
    this.table?.renderRows();
  }

  getValue() {
    this.itemChange('add');
    this.maintainFlag = true;

    if (this.getDataForTable?.data?.length > 0) {
      this.getDataForTable.data.forEach((row) => {
        row.expanded = false;
      });
    }
    this.table?.renderRows();
  }

  AddDuplicateData() {
    this.maintainFlag = false;
    this.itemChange('edit');
    this.ShowDuplicateBotton = false;
    this.getDataForTable.data.forEach((row) => {
      row.expanded = false;
    });
    setTimeout(() => {
      this.getDataForTable.data.forEach((row) => {
        if (
          row.USERPARTNERDISTRIBUTIONRATEGUID !=
          this.CurrentRowselcted.USERPARTNERDISTRIBUTIONRATEGUID
        ) {
          row.expanded = false;
        } else {
          this.ShowDuplicateBotton = true;
          this.CurrentRowselcted.expanded = true;
        }
      });
      this.table?.renderRows();
    }, 300);
  }

  CollapstExpandedrow() {
    this.CurrentRowselcted.expanded = false;
    this.table?.renderRows();
  }

  sortData() {
    this.getDataForTable.sortingDataAccessor = (item, property) => {
      if (property == 'EFFECTIVEFROMAMOUNT') {
        return parseFloat(item.EFFECTIVEFROMAMOUNT) || 0;
      }
      return item[property];
    };

    this.getDataForTable.sort = this.sort;
  }

  async sortDataval(data) {
    if (data?.direction == '') {
      return;
    }
    await this.SortingbehaviorService.accountSystemSortingPartner(data);
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => {
      // Collapse all expanded rows
      this.getDataForTable.data.forEach((row) => (row.expanded = false));
      this.table?.renderRows();
    });

    this.sort.sortChange.subscribe((sortState) => {
      if (sortState.direction === '') {
        this.sort.direction = 'asc';
        this.sort.active = sortState.active;

        this.getDataForTable.sort = this.sort;
      }
    });
  }
}
